import Rete from "rete";
import { NumberSocket } from "../../rete-controls/NumberControl.js";
import AnyTypeSocket, { ArraySocket } from "../../../Utils/CommonSockets.js";
import { ResetSocket } from "../../rete-controls/ResetControl.js";
import { EventBus } from '../../../event-bus.js';

export default class AnyArrayCollector extends Rete.Component {
  constructor() {
    super("Any Collector"); // name
    this._categories = ["Simulator"];

    this._nodeStateData = {};
    this._eventRegistered = false;
    EventBus.$on('global-reset-nodes', x => {
      this.doResetNode("all");
  });
  }

  buildNodeData(node) {
    if (node !== null && node !== undefined && node.id != undefined) {
      this._nodeStateData[node.id] = {
        myArray: [],
        currentIndex: null,
        currentConnectedInput: null,
        currentIndexWasConnected: false,

        reset() {
          this.myArray = [];
          this.currentIndex = null;
        }
      };
    }
  }
  registerOnRemove() {
    if (!this._eventRegistered) {
      var data = this._nodeStateData;
      this.editor.on("noderemoved", nodex => {
        console.log("removing " + nodex.id);

        if (data[nodex.id] !== null && data[nodex.id] !== undefined) {
          console.log("data gone " + nodex.id);

          delete data[nodex.id];
        }
      });
    }
    this._eventRegistered = true;
  }

  builder(node) {
    var inp1 = new Rete.Input("in1", "Any", AnyTypeSocket);
    var inp2 = new Rete.Input("in2", "Index", NumberSocket);
    var inp3 = new Rete.Input("resetIn", "Reset", ResetSocket);

    var out1 = new Rete.Output("out1", "Any Array", AnyTypeSocket);
    var out2 = new Rete.Output("out2", "Length", NumberSocket);

    
    this.buildNodeData(node);
    this.registerOnRemove();

    return node
      .addInput(inp1)
      .addInput(inp2)
      .addInput(inp3)
      .addOutput(out1)
      .addOutput(out2);
  }

  doResetNode(node) {
    if (node == "all") {
      for (const key in this._nodeStateData) {
        if (this._nodeStateData.hasOwnProperty(key)) {
          const element = this._nodeStateData[key];
          element.reset();
        }
      }
    } else {
      this._nodeStateData[node.id].reset();
    }
  }
  resetNode(in3, node) {
    if (node.inputs["resetIn"].connections[0] != null)
      if (in3 !== null && in3 !== undefined) this.doResetNode(node);
  }
  worker(node, inputs, outputs) {
    this.resetNode(inputs["resetIn"][0], node);
    let in1 = inputs["in1"][0];
    let in2 = inputs["in2"][0];
    let doAdd = false;

    let newConnection = node.inputs["in1"].connections[0];
    let indexConnection = node.inputs["in2"].connections[0];
    if (in1 !== [] && in1 !== undefined) {
      if (this._nodeStateData[node.id].currentConnectedInput != null) {
        if (
          newConnection.node !== this._nodeStateData[node.id].currentConnectedInput.node ||
          newConnection.output !== this._nodeStateData[node.id].currentConnectedInput.output
        ) {
          this._nodeStateData[node.id].currentConnectedInput = newConnection;
          this._nodeStateData[node.id].myArray.length = 0;
          this._nodeStateData[node.id].currentIndex = null;
        }
      } else {
        this._nodeStateData[node.id].currentConnectedInput = newConnection;
        this._nodeStateData[node.id].myArray.length = 0;
        this._nodeStateData[node.id].currentIndex = null;
      }

      doAdd = true;

      if (in2 != [] && in2 !== undefined) {
        in2 = +in2;
        if (this._nodeStateData[node.id].currentIndex !== in2) {
          this._nodeStateData[node.id].currentIndex = in2;
        } else {
          doAdd = false;
        }
        if (this._nodeStateData[node.id].currentIndexWasConnected == false) {
          doAdd = false;
          this._nodeStateData[node.id].currentIndexWasConnected = true;
        }
      } else if (this._nodeStateData[node.id].currentIndexWasConnected) {
        this._nodeStateData[node.id].currentIndexWasConnected = false;
        doAdd = false;
      }
    } else {
      if (newConnection == null) {
        this._nodeStateData[node.id].currentConnectedInput = null;
        this._nodeStateData[node.id].myArray.length = 0;
        this._nodeStateData[node.id].currentIndex = null;
      }
      if (indexConnection != null) {
        this._nodeStateData[node.id].currentIndexWasConnected = true;
      } else {
        this._nodeStateData[node.id].currentIndexWasConnected = false;
      }
    }

    if (doAdd) this._nodeStateData[node.id].myArray.push(in1);

    outputs["out1"] = this._nodeStateData[node.id].myArray;
    outputs["out2"] = this._nodeStateData[node.id].myArray.length;
  }
}
